export function getInvisibleSpace(calcs) {
    let invisibleSpace = calcs.container - calcs.wrapper;
    return Math.max(invisibleSpace, 0);
}
//# sourceMappingURL=getInvisibleSpace.js.map